import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import Layout from './Layout';
import LoadingSpinner from './LoadingSpinner';

const PrivateRoute = ({ children }) => {
  const { isAuthenticated, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return <LoadingSpinner />;
  }

  if (!isAuthenticated) {
    // Redireciona para login salvando a rota atual
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return (
    <Layout>
      {children}
    </Layout>
  );
};

export default PrivateRoute;